/**
 * Utility for consistent API error handling.
 * Parses errors from axios/fetch and returns a normalized Error.
 * @param {any} error - Original error object
 * @param {string} defaultMessage - Fallback error message
 * @returns {Error}
 */
export const handleApiError = (error, defaultMessage = 'An unexpected error occurred') => {
  let message = defaultMessage;

  if (error?.response) {
    const statusText = `${error.response.status} ${error.response.statusText}`;
    const raw = error.response.data?.message;
    if (typeof raw === 'string' && raw) {
      message = raw;
    } else if (Array.isArray(raw)) {
      // class-validator returns an array of constraint messages
      message = raw.filter(Boolean).join(', ') || statusText;
    } else if (raw && typeof raw === 'object') {
      // nested Nest exception body: { message, error, statusCode } — avoid
      // stringifying the object into a "[object Object]" banner
      message =
        (typeof raw.message === 'string' && raw.message) ||
        (typeof raw.error === 'string' && raw.error) ||
        statusText;
    } else {
      message = statusText;
    }
  } else if (error?.message) {
    message = error.message;
  }

  console.error(message, error);
  // Preserve response data + status on the thrown Error so callers can pull
  // structured fields (duplicateFacilityId, code, etc.) without losing access
  // to the underlying axios response.
  const wrapped = new Error(message);
  if (error?.response) {
    wrapped.response = error.response;
    wrapped.status = error.response.status;
  }
  return wrapped;
};
